
import whatsappFn from '~/mixins/whatsappFn.js';

    export default {
        name: "QdapHomeProductCard",
        mixins: [whatsappFn],
        props: {
            data: {
                type: Object,
                default: () => ({})
            }
        },

        computed: {
            insurerImg() {
                return this.data?.Logo?.url;
            },
            ctaLink() {
                return this.data?.ButtonLink;
            },
            features() {
                const item = this.data
                return [item?.Feature1, item?.Feature2, item?.Feature3, item?.Feature4];
            },
            promoTransData() {
                return {
                    PromotionCategory: this.data?.promo_trans?.PromotionCategory,
                    PromotionTitle: this.data?.promo_trans?.PromotionTitle,
                    CTAButtonLink: this.data?.promo_trans?.CTAButtonLink,
                    CTAButtonText: this.data?.promo_trans?.CTAButtonText,
                    Features: this.data?.promo_trans?.Features,
                    RelatedDocuments: this.data?.promo_trans?.RelatedDocuments,
                    disclaimer: this.data?.promo_trans?.disclaimer,

                    insurerCode: this?.data?.insurance_company?.insurance_company_translations[0]?.code,
                    insurerName: this?.data?.insurance_company?.insurance_company_translations[0]?.name,
                    productName: this.data?.Name,
                    promotionId: 'product_promotion?.id',
                    scenarioId: 'scenarioId',
                    lastCall: 'promotion_last_call'
                }
            }

        },
        methods: {
          async handleCTAClick(targetUrl) {
            await this.applyAdTrackingToWhatsappLink(targetUrl);
          },
          async applyAdTrackingToWhatsappLink(targetUrl) {
          }
        }
    }
